var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconNoBankAccount(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_699_907)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.1427 32.704H24.3418V47.351H30.1427V32.704Z",
    fill: "#205368"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9981 32.704H33.0977V47.351H35.9981V32.704Z",
    fill: "#205368"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8985 32.704H35.998V47.351H38.8985V32.704Z",
    fill: "#205368"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6564 32.704H41.8555V47.351H47.6564V32.704Z",
    fill: "#205368"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6545 32.704V47.351H41.8536V32.704H38.8985V47.351H35.998V54H52.1456V47.351H50.6096V32.704H47.6545Z",
    fill: "#ECBF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1456 26.6481H35.998V32.7039H52.1456V26.6481Z",
    fill: "#DDB401"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1456 26.6482L35.998 18V26.6482H52.1456Z",
    fill: "#ECBF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9991 47.351H33.0986V32.704H30.1435V47.351H24.3426V32.704H21.3875V47.351H19.8516V54H35.9991V47.351Z",
    fill: "#FFCF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9991 26.6481H19.8516V32.7039H35.9991V26.6481Z",
    fill: "#ECBF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9991 18L19.8516 26.6482H35.9991V18Z",
    fill: "#FFCF00"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 33,
    stroke: "#205368",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 13.5L60 60",
    stroke: "#205368",
    strokeWidth: 6
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_699_907"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNoBankAccount);
export default __webpack_public_path__ + "static/media/Icon_no_bank_account.510f958da748feff15aff34a3b708d10.svg";
export { ForwardRef as ReactComponent };